import { render, staticRenderFns } from "./CbsWidgetScalar.vue?vue&type=template&id=608ef1c6&scoped=true"
import script from "./CbsWidgetScalar.vue?vue&type=script&lang=js"
export * from "./CbsWidgetScalar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ef1c6",
  null
  
)

export default component.exports